import React, { Fragment, useEffect } from "react"
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";

const MAF = ({})=> {

  const currentUser = security.currentUserValue;
  const adUnitId    = "e1080741-54fb-460c-aa2f-e9147eec9a21"

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        scrolling="yes"
        frameBorder="0"
        src={`https://trk301.com?cid=2596716&pid=2371&adunit_id=${adUnitId}&user_id=${currentUser.id}&gender=&age=`}
      ></iframe>

    </Fragment>
  );
};

export default MAF;
